/* ============================================================
   ILUMEISTER.JS
   Gallery lightbox · Cart count · FAQ accordion
   ============================================================ */

(function () {
  'use strict';

  /* ── Gallery lightbox ── */
  function initGallery() {
    var grid      = document.getElementById('js-gallery-grid');
    var lightbox  = document.getElementById('js-lightbox');
    var lbImg     = document.getElementById('js-lightbox-img');
    var lbClose   = document.getElementById('js-lightbox-close');
    var lbPrev    = document.getElementById('js-lightbox-prev');
    var lbNext    = document.getElementById('js-lightbox-next');

    if (!grid || !lightbox) return;

    var items   = Array.from(grid.querySelectorAll('.lux-gallery__item'));
    var current = 0;

    function showItem(index) {
      var item = items[index];
      if (!item) return;
      lbImg.src = item.dataset.src || '';
      lbImg.alt = item.dataset.alt || '';
      current = index;
    }

    function openLightbox(index) {
      showItem(index);
      lightbox.classList.add('is-open');
      lightbox.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
      if (lbClose) lbClose.focus();
    }

    function closeLightbox() {
      lightbox.classList.remove('is-open');
      lightbox.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
      if (items[current]) items[current].focus();
    }

    items.forEach(function (item, i) {
      item.addEventListener('click', function () { openLightbox(i); });
    });

    if (lbClose)  lbClose.addEventListener('click', closeLightbox);
    if (lbPrev)   lbPrev.addEventListener('click', function () {
      showItem((current - 1 + items.length) % items.length);
    });
    if (lbNext)   lbNext.addEventListener('click', function () {
      showItem((current + 1) % items.length);
    });

    /* Keyboard nav */
    document.addEventListener('keydown', function (e) {
      if (!lightbox.classList.contains('is-open')) return;
      if (e.key === 'Escape')     closeLightbox();
      if (e.key === 'ArrowLeft')  showItem((current - 1 + items.length) % items.length);
      if (e.key === 'ArrowRight') showItem((current + 1) % items.length);
    });

    /* Touch swipe */
    var touchStartX = 0;
    lightbox.addEventListener('touchstart', function (e) {
      touchStartX = e.changedTouches[0].screenX;
    }, { passive: true });
    lightbox.addEventListener('touchend', function (e) {
      var dx = e.changedTouches[0].screenX - touchStartX;
      if (Math.abs(dx) < 40) return;
      if (dx < 0) showItem((current + 1) % items.length);
      else        showItem((current - 1 + items.length) % items.length);
    }, { passive: true });
  }

  /* ── Sticky mobile booking CTA (broneeri-aeg page) ── */
  function initStickyCTA() {
    var cta    = document.getElementById('js-sticky-cta');
    var widget = document.getElementById('booking-widget-container');
    if (!cta || !widget) return;

    var observer = new IntersectionObserver(
      function (entries) {
        var visible = entries[0].isIntersecting;
        cta.setAttribute('aria-hidden', visible ? 'true' : 'false');
        cta.style.display = visible ? 'none' : 'block';
      },
      { threshold: 0.1 }
    );
    observer.observe(widget);
  }

  /* ── Cart count badge ── */
  function initCartCount() {
    /* Shopify cart API — update badge if it exists in header */
    var badge = document.querySelector('[data-cart-count]');
    if (!badge) return;

    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        badge.textContent = cart.item_count;
        badge.style.display = cart.item_count > 0 ? 'flex' : 'none';
      })
      .catch(function () {});
  }

  /* ── FAQ accordion (details/summary) — native, but style icon ── */
  function initFAQ() {
    document.querySelectorAll('.faq-item').forEach(function (item) {
      item.addEventListener('toggle', function () {
        var icon = item.querySelector('.faq-item__icon');
        if (icon) icon.textContent = item.open ? '×' : '+';
      });
    });
  }

  /* ── Init all ── */
  document.addEventListener('DOMContentLoaded', function () {
    initGallery();
    initStickyCTA();
    initCartCount();
    initFAQ();
  });

})();
